import { dateToInt } from '../../../../../helpers/default_helper'
import { upload_file }                  from '../../../../../services/pages/reports/kualitatif/attachment/upload'
import getReportTypeByName              from '../../../../../services/pages/reports/kualitatif/get/getReportTypeByName'
import report_create                    from '../../../../../services/pages/reports/kualitatif/set/report_create'
import { FormatVal }                    from '../FormatValue'

const setTriKrama = ({
        bulan,
        tahun,
        nomor,
        tanggal_apel,
        pengucap,
        jumlah_pegawai,
        jumlah_peserta,
        data_pendukung,
}, isNihil) => {
        const promise = new Promise((resolve, reject) => {
                const nameReport = "Tri Krama Adhyaksa"
                let param = new FormData()
                for (let i in data_pendukung) {
                        param.append(`file[]`, data_pendukung[i])
                }
                if(!isNihil) {
                        upload_file(param).then(response => {
                                const { data: d }       = response
        
                                let attachments = []
        
                                if(response.data != null) {
                                        d.map((data) => {
                                                attachments.push({
                                                        code: "lampiran",
                                                        file_id: data.id,
                                                        file_name: data.name,
                                                        file_url: data.url
                                                })
                                        })
                                }
        
                                getReportTypeByName(nameReport).then(r => {
                                        const { data: { fields, id } } = r
                                        let paramSave = {
                                                report_type_id: id,
                                                values: [],
                                                attachments: []
                                        }
                                        let format = { ...FormatVal }
                                        let v = []
                                        fields.map(val => {
                                                switch (val.name) {
                                                        case "Bulan":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: "" + bulan,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Tahun":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: "" + tahun,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Tanggal Apel":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: "" + dateToInt(tanggal_apel),
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Nomor":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: nomor,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Pengucap":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: pengucap.name,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Jumlah Pegawai":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: jumlah_pegawai,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Jumlah Peserta Apel":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: jumlah_peserta,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "NIP":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: pengucap.nip,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "NRP":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: pengucap.nrp,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Pangkat":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: pengucap.grade,
                                                                }
                                                                v.push(format)
                                                                break;
                                                        case "Jabatan":
                                                                format = {
                                                                        ...format,
                                                                        field_id: val.id,
                                                                        value: pengucap.position,
                                                                }
                                                                v.push(format)
                                                                break;
                                                }
                                        })
        
                                        paramSave.values = v
                                        paramSave.attachments = attachments
        
                                        report_create(paramSave).then(response => {
                                                resolve(response)
                                        }).catch((err) => {
                                                reject(err)
                                        })
        
                                }).catch(err => { reject(err) })
                        })
                } else {
                        getReportTypeByName(nameReport).then(r => {
                                const { data: { fields, id } } = r
                                let paramSave = {
                                        report_type_id: id,
                                        values: [],
                                        attachments: []
                                }
                                let format = { ...FormatVal }
                                let v = []
                                fields.map(val => {
                                        switch (val.name) {
                                                case "Bulan":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "" + bulan,
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Tahun":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "" + tahun,
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Tanggal Apel":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Nomor":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Pengucap":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Jumlah Pegawai":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Jumlah Peserta Apel":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "NIP":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value:"Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "NRP":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Pangkat":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                                case "Jabatan":
                                                        format = {
                                                                ...format,
                                                                field_id: val.id,
                                                                value: "Nihil",
                                                        }
                                                        v.push(format)
                                                        break;
                                        }
                                })

                                paramSave.values = v
                                paramSave.nihil = isNihil
                                paramSave.attachments = []


                                report_create(paramSave).then(response => {
                                        resolve(response)
                                }).catch((err) => {
                                        reject(err)
                                })

                        }).catch(err => { reject(err) })
                }
        })
        return promise
}

export default setTriKrama;
